"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EliteOperatives() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const curators = [{
    role: "TACTICAL LEAD",
    name: "Jaxson Thorne",
    tenure: "PIXEL FORCE COMMANDER",
    quote: "Victory is not just about reflexes; it is about total map dominance.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/tactical_lead_jaxson.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/tactical_lead_jaxson.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/tactical_lead_jaxson.png-wvc-sizes",
    alt: "Jaxson Thorne, Tactical Lead, analyzing tournament data on a holographic display"
  }, {
    role: "COMMUNITY ARCHITECT",
    name: "Elena Vance",
    tenure: "DISCORD OPERATIONS LEAD",
    quote: "Building the strongest digital ecosystem for every gamer to thrive.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/community_lead_elena.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/community_lead_elena.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701752/img/community_lead_elena.png-wvc-sizes",
    alt: "Elena Vance, Community Architect, managing live stream events in the command center"
  }];
  return <section data-section-id="2400" id="elite-operatives" className="bg-background text-foreground py-32 md:py-48 px-6">
      <div className="max-w-[1200px] mx-auto">
        {}
        <div ref={headerRef} className={`text-center mb-20 md:mb-28 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono text-xs tracking-[0.3em] mb-8" style={{
          color: "var(--primary)"
        }}>
            — THE COMMANDERS
          </p>
          <h2 className="font-sans font-default text-4xl md:text-5xl lg:text-6xl leading-tight text-foreground mb-6">
            Elite Operatives, Tactical <span className="italic">Precision.</span>
          </h2>
          <p className="font-sans italic text-lg md:text-xl text-foreground/70 max-w-xl mx-auto">
            The architects of our competitive dominance and community growth.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-20 md:gap-24">
          {curators.map((curator, i) => {
          const {
            ref,
            isVisible
          } = useRevealOnScroll<HTMLDivElement>({
            threshold: 0.15
          });
          return <div data-index={i} key={i} ref={ref} className={`group transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                {}
                <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-card">
                  <img src={curator.image} data-wvc-srcset={curator.srcset} data-wvc-sizes={curator.sizes} alt={curator.alt} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.03]" />
                </div>

                {}
                <div className="mt-8">
                  {}
                  <div className="relative inline-block">
                    <p className="font-mono text-xs tracking-[0.25em] mb-4" style={{
                  color: "var(--primary)"
                }}>
                      {curator.role}
                    </p>
                    <span className="absolute left-0 -bottom-0 h-px w-0 group-hover:w-full transition-all duration-700 ease-out" style={{
                  backgroundColor: "var(--primary)"
                }} />
                  </div>

                  {}
                  <h3 className="font-sans font-default text-3xl md:text-4xl text-foreground mb-3">
                    {curator.name}
                  </h3>

                  {}
                  <p className="font-mono text-[10px] tracking-[0.25em] mb-6" style={{
                color: "var(--muted-foreground)"
              }}>
                    {curator.tenure}
                  </p>

                  {}
                  <p className="font-sans italic text-lg md:text-xl leading-relaxed text-foreground/80 mb-10 max-w-md">
                    “{curator.quote}”
                  </p>

                  {}
                  <Link to="/TheNexusPage" className="inline-flex items-center gap-2 font-mono text-xs tracking-[0.25em] pb-1 border-b transition-colors duration-300 hover:opacity-80" style={{
                color: "var(--primary)",
                borderColor: "var(--primary)"
              }}>
                    VIEW FULL DOSSIER
                    <ArrowRight className="size-3" />
                  </Link>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}